import type { IntlShape, MessageDescriptor } from 'react-intl';
import { isValidPhoneNumber } from 'react-phone-number-input';
import { z } from 'zod';

import { TRIAL_UPGRADE_REQUEST_CALLBACK_MESSAGE_MAX_LENGTH } from './constants';

export const trialUpgradeRequestCallbackMessageTooLongMsg: MessageDescriptor = {
  id: 'mZ8tVr4kBp',
  defaultMessage: 'Message must be {maxLength} characters or less',
  description:
    'Zod validation error when the trial upgrade request callback message exceeds the maximum length',
};

export const trialUpgradeRequestCallbackPhoneRequiredMsg: MessageDescriptor = {
  id: 'aN5sCk7fLy',
  defaultMessage: 'Contact number is required',
  description:
    'Zod validation error when the trial upgrade request callback phone number is empty',
};

export const trialUpgradeRequestCallbackPhoneInvalidMsg: MessageDescriptor = {
  id: 'bO9uDl2eMx',
  defaultMessage: 'Please enter a valid phone number',
  description:
    'Zod validation error when the trial upgrade request callback phone number is invalid',
};

export const createTrialUpgradeRequestCallbackModalSchema = (
  formatMessage: IntlShape['formatMessage']
) =>
  z.object({
    message: z
      .string()
      .trim()
      .max(TRIAL_UPGRADE_REQUEST_CALLBACK_MESSAGE_MAX_LENGTH, {
        message: formatMessage(trialUpgradeRequestCallbackMessageTooLongMsg, {
          maxLength: TRIAL_UPGRADE_REQUEST_CALLBACK_MESSAGE_MAX_LENGTH,
        }),
      })
      .optional()
      .default(''),
    phoneNumber: z
      .string()
      .min(1, { message: formatMessage(trialUpgradeRequestCallbackPhoneRequiredMsg) })
      .refine((value) => isValidPhoneNumber(value), {
        message: formatMessage(trialUpgradeRequestCallbackPhoneInvalidMsg),
      }),
  });

export type TrialUpgradeRequestCallbackModalFormValues = z.infer<
  ReturnType<typeof createTrialUpgradeRequestCallbackModalSchema>
>;
